<template>
  <router-view/>
</template>

<script>

export default {
  name: 'App',
  metaInfo: {
    title: 'Politik.sms',
    titleTemplate: '%s - Politik.sms',
    htmlAttrs: {
      lang: 'en',
      amp: true
    }
  },
  data: () => ({
    //
  }),
};
</script>
